import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { ConfirmationButton } from '../../common/components/formControls';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, onDelete, t, ...rest }) => {
	const columns = [
		{
			header: t('InstalmentPlanTemplate_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('InstalmentPlanTemplate_Center'),
			accessor: 'center.name',
			sortable: true
		},
		{
			header: t('InstalmentPlanTemplate_IntervalLength'),
			accessor: 'intervalLength',
			cell: (intervalLength, row) => `${intervalLength} ${row.intervalType === 1 ? t('InstalmentPlanTemplate_Weeks', { count: intervalLength }) : t('InstalmentPlanTemplate_Months', { count: intervalLength })}`,
			sortable: false
		},
		{
			header: t('InstalmentPlanTemplate_TotalPayments'),
			accessor: 'totalPayments',
			sortable: false
		},
		{
			header: t('InstalmentPlanTemplate_DepositPayments'),
			accessor: 'depositPayments',
			sortable: false
		},
		{
			header: t('InstalmentPlanTemplate_Enabled'),
			accessor: 'enabled',
			cell: (enabled) => ui.formatBoolean(enabled),
			sortable: true
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => <span><Link to={`/instalmentPlans/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={row.isReadonly ? faEye : faEdit} /> {t(row.isReadonly ? 'Common_View' : 'Common_Edit')}</Link> &nbsp;
				{!row.isReadonly && <ConfirmationButton
					onConfirmation={() => onDelete(id)}
					confirmationTitle={t('InstalmentPlanTemplate_DeleteConfirmationTitle')}
					confirmationMessage={t('InstalmentPlanTemplate_DeleteConfirmationMessage')}
					displayType={'inline'}
					label={t('Common_Delete')}
				/>}
			</span>
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={!isReadonly && <NewButton newItemPath='/instalmentPlans/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);